module.exports = __webpack_public_path__ + "public/img/离线.5bea1fef.png";